import { render } from "./HomeReview.vue?vue&type=template&id=56324460&scoped=true&lang=pug"
import script from "./HomeReview.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeReview.vue?vue&type=script&setup=true&lang=js"

import "./HomeReview.vue?vue&type=style&index=0&id=56324460&scoped=true&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56324460"]])

export default __exports__
import QRating from 'quasar/src/components/rating/QRating.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QRating});
